const menuData = [
  {
    id: 1,
    name: "Pizza Margherita",
    category: "Pizza",
    price: "$10",
    image: "https://images.unsplash.com/photo-1604382355076-af4b0eb60143?w=400"
  },
  {
    id: 2,
    name: "Cheeseburger",
    category: "Burger",
    price: "$8",
    image: "https://images.unsplash.com/photo-1550547660-d9450f859349?w=400"
  },
  {
    id: 3,
    name: "Pasta Carbonara",
    category: "Pasta",
    price: "$12",
    image: "https://images.unsplash.com/photo-1589302168068-964664d93dc0?w=400"
  },
  {
    id: 4,
    name: "Fresh Salad",
    category: "Salad",
    price: "$7",
    image: "https://images.unsplash.com/photo-1546793665-c74683f339c1?w=400"
  },
  {
  id: 5,
  name: "Pepperoni Pizza",
  category: "Pizza",
  price: "$12",
  image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?w=400"
},
{
  id: 6,
  name: "BBQ Burger",
  category: "Burger",
  price: "$11",
  image: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400"
},
{
  id: 7,
  name: "Caesar Salad",
  category: "Salad",
  price: "$9",
  image: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400"
}
];

export default menuData;